<template>
  <svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Info">
        <g v-if="circle" id="Oval-3" stroke="#FFFFFF" stroke-width="1">
          <circle cx="14.5" cy="14.5" r="14"></circle>
        </g>
        <text id="?" font-family="HelveticaNeue, Helvetica Neue" font-size="23" font-weight="normal" fill="#FFFFFF">
          <tspan x="8" y="23">?</tspan>
        </text>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    props: {
      'hasCircle': {
        type: Boolean,
        required: false
      }
    },
    data(){
      return{
        circle: this.hasCircle
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Help.vue